module.exports = __webpack_public_path__ + "static/mdtp-4218255788a50a8bebe4606e55eb65f5.png";